import { render, staticRenderFns } from "./SaleBatchFeatureBill.vue?vue&type=template&id=023275d7&"
import script from "./SaleBatchFeatureBill.vue?vue&type=script&lang=js&"
export * from "./SaleBatchFeatureBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports